import React, { Fragment, FunctionComponent} from "react";
import {Garage} from "@App/types";
import {Text} from "@eo-locale/react";

import {ServiceProviderHint} from "@App/components/common/ServiceProviderHint";


export type GarageProfileMOTProps = {
    garage: Garage
};


const GarageProfileMOTComponent: FunctionComponent<GarageProfileMOTProps> = ({garage}: GarageProfileMOTProps) => {


        return (
            <Fragment>
                {garage.checkpoint?.id && (
                    <div className={'col-span-full bg-gray-100 rounded-lg p-5 mb-5'}>
                        <h3 className={'text-lg font-serif mb-3'}><Text id={'checkpoint_title'}/></h3>
                        <div className={'inline-block md:inline-flex gap-3'}>

                            <ServiceProviderHint providerId={garage.checkpoint.id.toString()} hintType={'mot'} classes={'inline-block mx-auto my-0 md:mx-0 md:flex align-middle mr-2'} />

                            <p className={'md:basis-[70%]'}>
                                In dieser Werkstatt kannst du auch deine Hauptuntersuchung durchführen lassen. Ein Prüfer von {garage.checkpoint?.name} kommt dafür bei der Werkstatt vorbei.
                            </p>
                        </div>
                    </div>
                )}
            </Fragment>
        )
}

// Connect the component to the Redux store
export const GarageProfileMOT = GarageProfileMOTComponent
